import { ToastService } from '@philips-internal/oswald-ui-components';
import { ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';

import { Endpoint } from '../constants/endpoints';

interface PacsImageIdentifier {
  encounterId: string;
  examId: string;
  organizationId: string;
  patientId: string;
}

interface PacsIntegrationResult {
  url: string;
}

export default class PacsLinkGeneratorService {
  public static getPacsLink(imageId: PacsImageIdentifier): Promise<PacsIntegrationResult> {
    const { encounterId, examId, organizationId, patientId} = imageId;
    const params =  {
      encounterId,
      examId,
      organizationId,
      patientId
    };
    return HttpService.get(Endpoint.PACS_LINK_GENERATION, params, {}).then(r => r.body as PacsIntegrationResult);
  }

  public static openPacsInBrowser(imageId: PacsImageIdentifier): void {
    this.getPacsLink(imageId).then((pacsLinkResult: PacsIntegrationResult)  => {
      if (!pacsLinkResult || !pacsLinkResult.url) {
        ToastService.open({
          dismissible: true,
          highlight: false,
          id: 'pacs-integration-link',
          level: ToastLevel.WARNING,
          message: MessageService.translate('text.failed-run-integration-pacs'),
          showIcon: true,
          type: ToastType.BANNER,
        });
        return;
      }
      window.open(pacsLinkResult.url, '_blank');
    });
  }
}